import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../../app/service/proveedores/proveedores.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { lastValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-editar-registro-proveedor-dialog',
  templateUrl: './editar-registro-proveedor-dialog.component.html',
  styleUrl: './editar-registro-proveedor-dialog.component.scss'
})
export class EditarRegistroProveedorDialogComponent {

  proveedorForm: FormGroup
  errorValidarRfc = false
  errorValidarCuenta = false
  errorValidarCorreo = false
  errorTipoPersonaMessage = ""
  erroridCIFMessage = ""
  errorRFCMessage = ""
  errorClabeBancoMessage =""
  firstAccess = true
  model
  createdBy
  editMode = true
  headerTitle = 'Editar Proveedor'
  gallery = {
    group1: true,
    group2: false,
    group3: false,
    group4: false
  };
  mostrarError = {
    nombre: false,
    razonSocial: false,
    rfc: false,
    moneda: false,
    correo: false,
    direccion: false,
    telefono: false,
    contacto: false,
    noCuenta: false, 
    tipoCompra: false,
    tipoPersona: false,
    regimenFiscal: false,
    condicionesPago: false,
    formasPago: false,
    diasPago: false,
    banco: false,
    titular: false,
    idCif:false ,
    estadoetapa:false,
    estatus:false,
    ciudad: false,
    pais: false,
    estado: false,
    codigoPostal:false,
    empresa: false
  }
  paises = []
  estados = []
  tipoMoneda = []
  empresas = []
  formasPago = []
  tipoCompra = []
  bancos = []
  regimenFiscal = []
  condicionesPago = []
  estatus = []
  tipoPersona = []
  monedaSelect = []
  empresaSelect = []
  loadingView = true
  step = 1
  validEmail = false

  loadingProveedor = false
  csfValid = false 
  selectedFile: File | null = null;
  pdfSrc: SafeResourceUrl | null = null;
  pdfName: any = ''
  selectedFile2: File | null = null;
  pdfSrc2: SafeResourceUrl | null = null;
  pdfName2: any = ''
  selectedFile3: File | null = null;
  pdfSrc3: SafeResourceUrl | null = null;
  pdfName3: any = ''
  selectedFile4: File | null = null;
  pdfSrc4: SafeResourceUrl | null = null;
  pdfName4: any = ''
  rowCode = ''

  condicionPagoId: number;

  observaciones = ''

  show(groupName) {
    console.log(this.pdfSrc2)
    this.gallery.group1 = (groupName == 'group1') ? true : false;
    this.gallery.group2 = (groupName == 'group2') ? true : false;
    this.gallery.group3 = (groupName == 'group3') ? true : false;
    this.gallery.group4 = (groupName == 'group4') ? true : false;
  }
  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private provedorService: ProveedoresService,
    public dialogRef: MatDialogRef<EditarRegistroProveedorDialogComponent>) {
      this.proveedorForm = this.fb.group({
        clave: ['', [Validators.required]],
        nombre: ['', [Validators.required]],
        razonSocial: [{value:'', disabled: true}],
        tipo: ['', [Validators.required]],
        rfc: ['', [Validators.required]],
        moneda: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        ciudad: [{value: '', disabled: true}, [Validators.required]],
        pais: ['', [Validators.required]],
        estado: ['', [Validators.required]],
        codigoPostal: ['', [Validators.required]],
        telefono: ['', [Validators.required]],
        correo: ['', [Validators.required]],
        contacto: ['', [Validators.required]],
        noCuenta: ['', [Validators.required]],
        condicionesPago: ['', [Validators.required]],
        tipoCompra: ['', [Validators.required]],
        tipoPersona: ['', [Validators.required]],
        regimenFiscal: ['', [Validators.required]],
        diasPago: [1,[Validators.min(1), Validators.max(61)]],
        formasPago: ['', [Validators.required]],
        titular: ['', [Validators.required]],
        estatus: ['', [Validators.required]],
        idRfc: ['', [Validators.required]],
        banco:  ['', [Validators.required]]
      })

      this.editMode = data.editable
      this.getTipoMoneda()
      this.getTipoCompra()
      //this.getFormasPago()
      this.getCondicionesPago()
      this.getEstatus()
      this.getRegimenFiscal()
      this.getTipoPersona()
      this.getBancos()
      this.getProveedorData(data.proveedor)
      this.getEmpresas()
      if(data.mostrarDocumentos){
        this.step = 4
      }
  }

  ngOnInit() {

  }

  getEmpresas(){
    this.provedorService.getEmpresas(localStorage.getItem('id')).subscribe(
      data => {
        this.empresas = data
      }
    )
  }
  async getPaises(){
    this.paises = await lastValueFrom(this.provedorService.getPaises())
    // console.log(this.proveedorForm.value)
    this.getEstados()
  }

  async getEstados(){
    this.estados = await lastValueFrom(this.provedorService.getEstadosPorPais(this.proveedorForm.getRawValue().pais))
  }
  
  getTipoMoneda(){
    this.provedorService.getTiposMoneda().subscribe(
      data => {
        this.tipoMoneda = data
      }
    )
  }
  
  getTipoCompra(){
    this.provedorService.getTiposCompra().subscribe(
      data => {
        this.tipoCompra = data
      }
    )
  }

  getEstatus(){
    this.provedorService.getProveedoresEstatus().subscribe(
      data => {
        this.estatus = data
      }
    )
  }

  getFormasPago(id, formaPagoId){
    
    //const condicionPagoId = this.proveedorForm.get('condicionesPago')?.value;
    this.provedorService.getFormaPago(id).subscribe(
      data => {
        this.formasPago = data
        this.proveedorForm.get('formasPago').setValue(formaPagoId);
      }
    )
  }

  getCondicionesPago(){
    this.provedorService.getCondicionesPago().subscribe(
      data => {
        this.condicionesPago = data
      }
    )
  }

  getRegimenFiscal(){
    this.provedorService.getRegimenFiscal().subscribe(
      data => {
        this.regimenFiscal = data
      }
    )
  }

  getBancos(){
    this.provedorService.getBancos().subscribe(
      data => {
        this.bancos = data
      }
    )
  }
  
  getTipoPersona(){
    this.provedorService.getTipoPersona().subscribe(
      data => {
        this.tipoPersona = data
      }
    )
  }

  getProveedorData(proveedor){
    this.provedorService.getProveedorPorClave(proveedor.claveProveedor).subscribe(
      datos => {
        let data = datos[0]
        this.createdBy = data.createdBy
        this.proveedorForm = this.fb.group({
          clave: [data.claveProveedor, [Validators.required]],
          nombre: [data.nombreProveedor, [Validators.required]],
          razonSocial: [data.razonSocial, [Validators.required]],
          rfc: [data.rfc, [Validators.required]],
          moneda: [data.moneda, [Validators.required]],
          direccion: [data.direccion, [Validators.required]],
          telefono: [data.telefono, [Validators.required]],
          correo: [data.email, [Validators.required]],
          contacto: [data.contactoFacturacion, [Validators.required]],
          noCuenta: [data.numerodeCuenta, [Validators.required]],
          ciudad: [data.ciudad, [Validators.required]],
          pais: [data.paisId, [Validators.required]],
          estado: [data.entidadId, [Validators.required]],
          codigoPostal: [data.codigoPostal, [Validators.required]],
          condicionesPago: [data.condiciondePagoId, [Validators.required]],
          tipoCompra: [data.tipoCompra, [Validators.required]],
          diasPago: [data.diasdePago, [Validators.min(1), Validators.max(61)]],
          tipoPersona: [data.tipoProveedor, [Validators.required]],
          regimenFiscal: [data.regimenFiscal, [Validators.required]],
          formasPago: [data.formaPagoId, [Validators.required]],
          titular: [data.nombreTitular, [Validators.required]],
          estatus: new FormControl({value: data.estatus, disabled: localStorage.getItem('profile') === 'Administrador' ? true : true}, [Validators.required]),
          idRfc: [data.idCIF, [Validators.required]],
          banco:  [data.bancosId, [Validators.required]]
        })

        data.tiposMonedaProveedor.forEach(element => {
          this.monedaSelect.push(element.tipoMonedaId)
        });
        data.proveedorEmpresa.forEach(element => {
          this.empresaSelect.push(element.empresaId)
        });
        this.observaciones = data.observacion
        data.documentosproveedor.forEach(element => {
          if(element.claveDocumento === 'CSF'){
            this.pdfName = element.archivo
            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);            
          }else if(element.claveDocumento === 'CD'){
            this.pdfName2 = element.archivo
            this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'CB'){
            this.pdfName3 = element.archivo
            this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }else if(element.claveDocumento === 'REP'){
            this.pdfName4 = element.archivo
            this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(element.url);
          }

          if(this.pdfSrc=='' || this.pdfSrc2 == '' || this.pdfSrc3=='')
          { 
              this.csfValid = false
          }
          else{
            this.csfValid = true
          }
        });
        this.loadingView = false
        this.rowCode = data.rowVersion
        this.getPaises()
        this.habilitarRFC();
        this.validarEmail(this.proveedorForm.value.correo);   
        
        this.condicionPagoId = data.condiciondePagoId;
        this.getFormasPago(this.condicionPagoId,data.formaPagoId)

      }
    )
  }

  validarEmail($event){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegex.test($event)){
      this.validEmail = true
      this.errorValidarCorreo = false
    }else{
      this.validEmail = false
      this.errorValidarCorreo = true
    }
    
  }

  validateStep(opc){
    this.resetErrors()
    if(this.step === 1){
      if(this.proveedorForm.value.nombre !== '' && this.proveedorForm.value.razonSocial !== '' && this.proveedorForm.value.rfc !== ''  && this.monedaSelect.length > 0  && this.proveedorForm.value.estatus !== '' &&  this.empresaSelect.length > 0 ){
        this.nextStep(opc)
      }else{
        this.mostrarError.nombre = this.proveedorForm.value.nombre !== '' ? false : true
        this.mostrarError.razonSocial = this.proveedorForm.value.razonSocial !== '' ? false : true
        this.mostrarError.rfc = this.proveedorForm.value.rfc !== '' ? false : true
        this.mostrarError.moneda = this.proveedorForm.value.moneda !== '' ? false : true
        this.mostrarError.estatus = this.proveedorForm.value.estatus !== '' ? false : true
        this.mostrarError.empresa = this.proveedorForm.value.empresa !== '' ? false : true
      }
    }else if(this.step === 2){
      if(this.proveedorForm.value.correo !== '' && this.proveedorForm.value.direccion !== '' && this.proveedorForm.value.telefono !== '' && this.proveedorForm.value.contacto !== '' && this.proveedorForm.getRawValue().pais !== '' && this.proveedorForm.getRawValue().estado !== '' && this.proveedorForm.getRawValue().codigoPostal !== ''){
        this.nextStep(opc)
      }else{
        this.mostrarError.correo = this.proveedorForm.value.correo !== '' ? false : true
        this.mostrarError.direccion = this.proveedorForm.value.direccion !== '' ? false : true
        this.mostrarError.telefono = this.proveedorForm.value.telefono !== '' ? false : true
        this.mostrarError.contacto = this.proveedorForm.value.contacto !== '' ? false : true
        this.mostrarError.pais = this.proveedorForm.getRawValue().pais !== '' ? false : true
        this.mostrarError.estado = this.proveedorForm.getRawValue().estado !== '' ? false : true
        this.mostrarError.codigoPostal = this.proveedorForm.getRawValue().codigoPostal !== '' ? false : true
        this.mostrarError.ciudad = this.proveedorForm.getRawValue().ciudad !== '' ? false : true
      }
    }else if(this.step === 3){
      if(this.proveedorForm.value.noCuenta !== '' && this.proveedorForm.value.tipoCompra !== '' && this.proveedorForm.value.regimenFiscal !== '' && this.proveedorForm.value.condicionesPago !== '' && this.proveedorForm.value.diasPago !== '' && this.proveedorForm.value.banco !== '' && this.proveedorForm.value.formasPago !== '' && this.proveedorForm.value.titular !== '' && !this.errorValidarCuenta){
        this.nextStep(opc)
      }else{
        this.mostrarError.noCuenta = this.proveedorForm.value.noCuenta !== '' ? false : true
        this.mostrarError.banco = this.proveedorForm.value.banco !== '' ? false : true
        this.mostrarError.formasPago = this.proveedorForm.value.formasPago !== '' ? false : true
        this.mostrarError.tipoCompra = this.proveedorForm.value.tipoCompra !== '' ? false : true
        this.mostrarError.regimenFiscal = this.proveedorForm.value.regimenFiscal !== '' ? false : true
        this.mostrarError.condicionesPago = this.proveedorForm.value.condicionesPago !== '' ? false : true
        this.mostrarError.diasPago = this.proveedorForm.value.diasPago !== '' ? false : true
        this.mostrarError.titular = this.proveedorForm.value.titular !== '' ? false : true
      }
    }else{
      this.nextStep(opc)
    }
  }

  nextStep(opc){
    opc === 1 ? this.step ++ : this.step --
  }

  async guardarProveedor(){
    
    // if(this.pdfName !== ''){
    //   await this.enviarArchivo(1)
    // }

    if(!this.loadingProveedor){
      this.loadingProveedor = true
      if(this.pdfName2 !== ''){
        await this.enviarArchivo(2)
      }

      if(this.pdfName3 !== ''){
        await this.enviarArchivo(3)
      }

      if(this.pdfName4 !== ''){
        await this.enviarArchivo(4)
      }

      let body = {
        proveedorId: this.data.proveedor.proveedorId,
        claveProveedor: this.data.proveedor.claveProveedor,
        nombreProveedor: this.proveedorForm.value.nombre.toUpperCase(),
        razonSocial: this.proveedorForm.value.razonSocial?? '',
        //razonSocial: this.proveedorForm.value.razonSocial,
        tipoProveedor: this.proveedorForm.value.tipoPersona,
        regimenFiscal: this.proveedorForm.value.regimenFiscal,
        rfc: this.proveedorForm.value.rfc,
        createdBy: this.createdBy,
        ciudad: this.proveedorForm.value.ciudad,
        paisId: this.proveedorForm.getRawValue().pais,
        entidadId: this.proveedorForm.getRawValue().estado,
        codigoPostal: this.proveedorForm.getRawValue().codigoPostal,
        tipoCompra: this.proveedorForm.value.tipoCompra,
        direccion: this.proveedorForm.value.direccion,
        telefono: this.proveedorForm.value.telefono,
        email: this.proveedorForm.value.correo,
        contactoFacturacion: this.proveedorForm.value.contacto.toUpperCase(),
        numerodeCuenta: this.proveedorForm.value.noCuenta,
        nombreTitular: this.proveedorForm.value.titular.toUpperCase(),
        condiciondePagoId: this.proveedorForm.value.condicionesPago,
        formaPagoId: this.proveedorForm.value.formasPago,
        idCIF: this.proveedorForm.value.idRfc,
        diasdePago: this.proveedorForm.value.diasPago,
        bancosid: this.proveedorForm.value.banco,
        estatus: 1,
        updatedBy: localStorage.getItem('id'),
        documentosproveedor: this.obtenerCamposPdf(),
        tiposMonedaProveedor: this.obtenerMulti(),
        rowVersion: this.rowCode,
        proveedorEmpresa: this.obtenerMultiEmpresa()            
      }

      if(this.proveedorForm.value.tipoCompra === '2'){
        body.documentosproveedor.push({
          "claveDocumento": "REP",
          "archivo": this.proveedorForm.value.rfc+'-REP.pdf',
          "estatus": true
        })
      }

      this.provedorService.putGuardarProveedor(body).subscribe(
        data => {
          if(data.code === 400){            
            const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto',
              data: {
                message: data.message                
              }
            });
            this.loadingProveedor = false
          }else if(data.code === 200){
            this.dialogRef.close({event: 1, data: data})
            this.loadingProveedor = false
          }
        },
        error => {
          console.log(error)
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            width: 'auto',
            data: {
              isError: true,
              message: error.error.message                
            }
          });
          this.loadingProveedor = false
          this.getProveedorData(this.data.proveedor)
        }
      )
    }
  }

  obtenerCamposPdf(){

    let array = [
      {
        "claveDocumento": "CSF",
        "archivo": this.proveedorForm.value.rfc+'-CSF.pdf',
        "estatus": true
      },
      {
        "claveDocumento": "CB",
        "archivo": this.proveedorForm.value.rfc+'-CB.pdf',
        "estatus": true
      }
    ]

    if(this.pdfSrc2){
      array.push(
      {
          "claveDocumento": "CD",
          "archivo": this.proveedorForm.value.rfc+'-CD.pdf',
          "estatus": true
      })
    }
    return array
  }

  enviarArchivo(opc){
    const formData = new FormData();
    if(opc === 1){
      formData.append('fileProvider', this.selectedFile);
      formData.append('idcif', this.proveedorForm.value.idRfc);
    }else if(opc === 2){
      formData.append('fileProvider', this.selectedFile2);
    }else if(opc === 3){
      formData.append('fileProvider', this.selectedFile3);
    }else if(opc === 4){
      formData.append('fileProvider', this.selectedFile4);
    }
     this.provedorService.enviarPdf(formData).subscribe(
      data => {
        if(opc === 1){
          if(data.code === 400){
            this.csfValid = false
            if(data.nombrecomercial!== this.proveedorForm.get('nombre').value && data.idcif !== '')
              {
                this.csfValid = false
                const dialogRef = this.dialog.open(ErrorDialogComponent, {
                  width: 'auto', 
                  data: 
                  {
                    message: data.message,
                    isError: true
                  }

                });
              }
              else{
                  const dialogRef = this.dialog.open(ErrorDialogComponent, {
                  width: 'auto',
                  data: {
                    message: data.message,
                    isError: true
                  }                
                });
              }
            /*const dialogRef = this.dialog.open(ErrorDialogComponent, {
              width: 'auto',
              data: {
                message: data.message,
                isError: true
              }
              
            });*/
          }else{
            this.csfValid = true
          }
        }
      }
    )
  }

  closeDialog(){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: 'auto',
      disableClose: true,
      data: {
        message: '¿Deseas salir de la carga del proveedor?',
        description: 'Si confirmas, el progreso se borrará',
        confirmButton: 'Salir'
      }
    });
      dialogRef.afterClosed().subscribe(result => {
      if(!!result){
        if(result.event !== 1){
          return
        }else if(result.event === 1){
          this.dialogRef.close({event: 2})
        }
      }
    });
  }

  onFileSelected(event: any, opc): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.previewPDF(file, opc, event);
    } else {
      const dialogRef = this.dialog.open(ErrorDialogComponent, {
        width: 'auto',
        data: {
          message: 'Por favor, selecciona un archivo PDF'
        }
      });
    }
  }

  previewPDF(file: File, opc, $event): void {
    const reader = new FileReader();
    console.log('ENTRO AL PREVIEW')
    reader.onload = async (e: any) => {
      const pdfData = e.target.result;
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      if(opc === 1){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CSF.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName = auxFile.name
        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile = auxFile;
        await this.enviarArchivo(1)
      }else if(opc === 2){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CD.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName2 = auxFile.name
        this.pdfSrc2 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile2 = auxFile;
      }else if(opc === 3){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-CB.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName3 = auxFile.name
        this.pdfSrc3 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile3 = auxFile;
      }else if(opc === 4){
        const auxFile = new File([$event.target.files[0]], this.proveedorForm.value.rfc+'-REP.pdf', {
          type: $event.target.files[0].type
        })
        this.pdfName4 = auxFile.name
        this.pdfSrc4 = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.selectedFile4 = auxFile;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  resetErrors(){
    this.mostrarError = {
      nombre: false,
      razonSocial: false,
      rfc: false,
      moneda: false,
      correo: false,
      direccion: false,
      telefono: false,
      contacto: false,
      noCuenta: false, 
      tipoCompra: false,
      tipoPersona: false,
      regimenFiscal: false,
      condicionesPago: false,
      diasPago: false,
      titular: false,
      banco: false,
      formasPago: false,
      idCif:false,
      estadoetapa:false,
      estatus:false,
      ciudad: false,
      pais: false,
      estado: false,
      codigoPostal:false,
      empresa: false
    }
  }

  resetUploadFile(opc){
    if(opc === 1){
      this.pdfName = ''
      delete this.pdfSrc
      delete this.selectedFile
    }else if(opc === 2){
      this.pdfName2 = ''
      delete this.pdfSrc2
      delete this.selectedFile2
    }else if(opc === 3){
      this.pdfName3 = ''
      delete this.pdfSrc3
      delete this.selectedFile3
    }else if(opc === 4){
      this.pdfName4 = ''
      delete this.pdfSrc4
      delete this.selectedFile4
    }
    // this.file_loaded = []; 
    // this.wrongFileExtension = false
  }

  repseHabilitado(){
    return this.proveedorForm.value.tipoCompra === 2 ? true : false 
  }

  validarRFC(){
    let body = {
      rfc: this.proveedorForm.value.rfc,
      tipopersona: this.proveedorForm.value.tipoPersona === '1' ? 'F' : 'M',
      operacion: 'U',
      idCIF: this.proveedorForm.value.idRfc
    }
    
   this.provedorService.validarRFC(body).subscribe(
      data => {
        if(data.code === 400)
        {
          const rfcValidaTP = this.proveedorForm.value.rfc?.trim();
          const tipo = this.proveedorForm.value.tipoPersona;

          const longitudEsperada = tipo === '1' ? 13 : tipo === '2' ? 12 : null;

          if (longitudEsperada && rfcValidaTP?.length !== longitudEsperada) 
          {
            this.errorRFCMessage = 'El RFC no corresponde con el tipo de persona seleccionado.';
          }          
          else
          {
            this.errorRFCMessage = data.message
          }

          this.errorValidarRfc = true
          
        }else{
          let sat = {
            RFC: this.proveedorForm.value.rfc,
            Tipopersona: this.proveedorForm.value.tipoPersona === '1' ? 'F' : 'M',
            idCIF: this.proveedorForm.value.idRfc
          }
          this.provedorService.validarIdRFC(sat).subscribe(
            data2 => {
              if(data2.code === 400){
                this.errorValidarRfc = true
                this.errorRFCMessage = data2.message
              }else{
                this.errorValidarRfc = false
              }
            }
          )
        }
        this.firstAccess = true
      }
    )
  }

  validarCuenta(){
    const banco = this.bancos.find(element => element.bancosId === parseInt(this.proveedorForm.value.banco))
    let body = {
      clave: banco.clave,
      cuenta: this.proveedorForm.value.noCuenta
    }
    
    this.provedorService.getValidarBanco(body).subscribe(
      data => {
        if(data.code === 400){
          this.errorValidarCuenta = true
          this.mostrarError.noCuenta = true
          this.errorClabeBancoMessage = data.message
        }else{
          this.errorValidarCuenta = false
          this.mostrarError.noCuenta = false
        }
      },
      err => {
        this.errorValidarCuenta = false
        this.mostrarError.noCuenta = false
      }
    )
  }

  checkFirstAccess(){
    this.firstAccess = false
  }

  checkMinMax(){
    const inputControl = this.proveedorForm.get('diasPago');
    if (inputControl) {
      const value = inputControl?.value;
      if (value <= 0) {
        inputControl?.setValue(1);
      } else if (value > 61) {
        inputControl?.setValue(60);
      }
    }
  }

  validarCaracteres(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    const valorLimpio = valor.replace(/[^a-zA-Z\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }
    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }

  validarRfc(){
    const valor = this.proveedorForm.get('rfc')?.value || ''
    const valorLimpio = valor.replace(/[^a-zA-Z0-9\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get('rfc').setValue(valorLimpio, {
        emitEvent: false
      })
    }
  }

  validarEspeciales(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    const valorLimpio = valor.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s]/g, '')
    if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }

    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }

  validarNumeros(campo){
    const valor = this.proveedorForm.get(campo)?.value || ''
    const valorLimpio = valor.replace(/[^0-9\s]/g, '')
     if(valor !== valorLimpio){
      this.proveedorForm.get(campo).setValue(valorLimpio, {
        emitEvent: false
      })
    }
    if(this.proveedorForm.get(campo).value !== '')
      {
        this.mostrarError[campo] = false
      }
      else
      {
        this.mostrarError[campo] = true
      }
  }


  habilitarRFC(){
    const control = this.proveedorForm.get('rfc')
    if(this.proveedorForm.get('tipoPersona').value !== '')
    {
      this.mostrarError.tipoPersona = false
      this.mostrarError.idCif = false
      this.erroridCIFMessage =""
      this.errorTipoPersonaMessage=""
      if(this.proveedorForm.get('idRfc').value !== '')
      {
        control.enable()        
      }
      else
      {
        this.mostrarError.idCif = true
        this.erroridCIFMessage =  "Ingresa el IdCIF del proveedor"
        control.disable
      }

      if(this.proveedorForm.get('tipoPersona').value == '1')
      {
        this.proveedorForm.get('razonSocial').reset()
        this.proveedorForm.get('razonSocial')?.disable()
      }
      else
      {
        this.proveedorForm.get('razonSocial')?.enable()
      }
    }
    else
    {       
      this.mostrarError.tipoPersona = true
      this.errorTipoPersonaMessage ="Se requiere seleccionar el tipo de persona"
      control.disable
      this.proveedorForm.get('razonSocial')?.disable()
    }
  }

  obtenerMulti(){
      let auxMoneda = []
      this.tipoMoneda.forEach(element => {
        let auxEl = element
        if(this.monedaSelect.includes(element.tipoMonedaId)){
          auxEl['estatus'] = true
          auxMoneda.push(auxEl)
        }else{
          auxEl['estatus'] = false
          auxMoneda.push(auxEl)
        }
      });

      return auxMoneda
  }
  obtenerMultiEmpresa(){
      let auxEmpresa = []
      this.empresas.forEach(element => {
        let auxEm = { ...element };

        if(this.empresaSelect.includes(element.empresaId)){
          auxEm.esActivo = true         
        }else{
          auxEm.esActivo = true                     
        }
        auxEm.createdBy = localStorage.getItem('id');
        auxEmpresa.push(auxEm)
      }); 

      return auxEmpresa
  }

  validarArchivos(){
    let repse = this.proveedorForm.value.tipoCompra === '2' ? true : false 

    if(this.pdfSrc && this.pdfSrc3){
      if(repse){
        if(this.pdfSrc4){
          return true
        }
      }else{
        return true
      }
    }
    
    return false
    
  }

  onPaisChange(event: Event){
    this.provedorService.getEstadosPorPais((event.target as HTMLSelectElement).value).subscribe(
      data => {
        this.estados = data
      }
    )
  }
  validarSeleccion() {
    if (!this.empresaSelect || this.empresaSelect.length === 0) {
      this.mostrarError.empresa = true;
    } else {
      this.mostrarError.empresa = false;
    }

    if (!this.monedaSelect || this.monedaSelect.length === 0) {
      this.mostrarError.moneda = true;
    } else {
      this.mostrarError.moneda = false;
    }
  }

   onCondicionPagoChange(condicionPagoId: string) {
    this.getFormasPago(condicionPagoId,0);
  }
}
